<template>
  <DatatableReportV3
    title="Sold Line Items"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "invoice_date",
            title: "Invoice Date",
            filterName: "sold_on",
            searchable: false
          },
          {
            data: "customer",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers
          },
          { data: "email" },
          { data: "phone" },
          { data: "location_name", title: "Location Name" },
          { data: "address", orderable: false },
          { data: "invoice" },
          { data: "job" },
          {
            data: "technician",
            title: "Opp. Owner",
            filterName: "technician_id"
          },
          {
            data: "department",
            filterName: "department_id",
            searchable: false
          },
          { data: "category", filterName: "li_category", searchable: false },
          {
            data: "line_item",
            title: "Line Item",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.items,
            filterName: "line_item_ids",
            footerClassName: "text-left"
          },
          {
            data: "quantity",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.sold,
            searchable: false
          },
          {
            data: "total_price",
            title: "Price",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.revenue,
            searchable: false
          },
          {
            data: "price_adjustment",
            title: "Price Adjustment",
            searchable: false,
            orderable: false
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Sold Line Items" });
  }
};
</script>

<style lang="scss" scoped></style>
